import React, {useState} from 'react';
import './CustomDatePicker.css';
import DatePicker from "react-datepicker";
import { Portal } from 'react-overlays';
import {useTranslation} from "react-i18next";

const CalendarContainer = ({children}) => {
    const el = document.getElementById('calendar-portal')
    return (
        <Portal container={el}>
            {children}
        </Portal>
    )
}

const CustomDatePicker = (props) => {

    const {t} = useTranslation();

    let label = props.label ? props.label : t('ClientDetails.Profile.Accounts.value_as_of_date');
    let labelClass = props.isEditMode ? "label-editable" : "label-readonly";
    let minDate = props.minDate ? props.minDate : new Date("1900/01/01");
    let maxDate = props.maxDate ? props.maxDate : new Date("2150/12/31");
    let format = props.format ? props.format : "MM/dd/yyyy";
    let selectedDate = props.selectedDate ? props.selectedDate : new Date();
    let style = props.style ? props.style : {};

    const onChange = (e) => {
        props.update(e);
    };

    return (
        <div className="custom-date-picker" style={style}>
            <div className={labelClass}>{label}</div>
            <DatePicker
                popperContainer={CalendarContainer}
                className="value-date-dropdown date-picker-component"
                minDate={minDate}
                maxDate={maxDate}
                disabled={!props.isEditMode}
                format={format}
                selected={selectedDate}
                onChange={(date) => onChange({target: {value: date}})}
            />
        </div>
    );
};

export default CustomDatePicker;